import { Observable } from "rxjs";
import api from "@/services/api-config/rxjs-config";
import { LessonPlan } from "@/models/lessonPlan.model";

export class LessonPlanRest {
  getLessonPlan(learningObject: string): Observable<LessonPlan[]> {
    const url: string = `/learning-objectives/${learningObject}/lesson-plans`;
    return api.get(url, {}, "/graphs");
  }
  getLessonPlanById(
    learningObject: string,
    lessonPlanId: string
  ): Observable<any> {
    const url: string = `/learning-objectives/${learningObject}/lesson-plans/${lessonPlanId}`;
    return api.get(url, {}, "/graphs");
  }
  getMaterialsByLessonPlan(lessonPlanId: string): Observable<any> {
    const url: string = `/lesson-plans/${lessonPlanId}/materials`;
    return api.get(url, {}, "/graphs");
  }
  postMaterialsInLessonPlan(
    lessonPlanId: string,
    materialId: string
  ): Observable<any> {
    const url: string = `/lesson-plans/${lessonPlanId}/materials/${materialId}/reference`;
    return api.post(url, {}, {}, "/graphs");
  }
  deleteMaterialsInLessonPlan(
    lessonPlanId: string,
    materialId: string
  ): Observable<any> {
    const url: string = `/lesson-plans/${lessonPlanId}/materials/${materialId}/reference`;
    return api.delete(url, "/graphs");
  }
  editMaterialsInLessonPlan(
    objectiveId: string,
    lessonPlanId: string,
    materials: any
  ): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/lesson-plans/${lessonPlanId}`;
    return api.put(url, materials, {}, "/graphs");
  }
}
